import * as React from "react";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import {IInsuranceOrder} from "StateInterface";
import {handleNavigation, RoutePaths} from "../routes";
import {getUserOrders} from "insurance/actions";
import {floatingNavButton, downloadPdfFromPreSignedUrl} from "insurance/utils";
import Loading from "components/loading";
import {imageBaseUrl} from "config";
import {getPreSignedUrl} from "insurance/api";

interface IConnectProps {
    dispatch?: (action: any) => void;
    userId: number;
    orders: IInsuranceOrder[];
    orderResponse: string;
    insuranceBase64Document: string;
    isAndroid: boolean;
}
interface IState {
    containerClass: string;
    clickedCardIndex: number;
    isDownloadClicked: boolean;
    insurancePolicyDocError: string;
    loading: boolean;
}
const ACTIVE = "ACTIVE";

class ActiveInsurances extends React.Component<IConnectProps, IState> {
    constructor(props) {
        super(props);
        this.state = {
            containerClass: null,
            clickedCardIndex: null,
            isDownloadClicked: false,
            insurancePolicyDocError: null,
            loading: false,
        };
    }
    public componentDidMount() {
        if (!this.props.orders && !this.props.orderResponse) {
            this.props.dispatch(getUserOrders());
        }
        const containerClass = document.body.scrollHeight > screen.height ? "" : "add-padding";
        this.setState({containerClass});
    }
    public renderAllInsurances = () => {
        if (this.props.orders.length > 0) {
            return this.props.orders.map((product, index) => {
                return this.renderInsuranceCart(product, index);
            });
        } else {
            return (
                <div>
                    You haven't purchased any insurance.
                </div>
            );
        }
    }
    public handleClickedCardIndexChange = (index: number) => {
        this.setState({clickedCardIndex: index === this.state.clickedCardIndex ? null : index});
    }

    public handleDownloadInsurance = async (index: number) => {
        this.setState({insurancePolicyDocError: ""});
        this.handleClickedCardIndexChange(index);
        this.setState({loading: true});
        try {
            const response = await getPreSignedUrl(this.props.orders[index].orderId);
            await downloadPdfFromPreSignedUrl(response.data.preSignedUrl, this.props.isAndroid);
            this.setState({loading: false});
        } catch (e) {
            this.setState({loading: false});
            this.setState({ insurancePolicyDocError: "Your policy not yet generated, mail us for more details"});
        }
    }

   public renderInsuranceCart = (product: IInsuranceOrder, key) => {
        return (
            <div className="insurance-card" key={key}>
                <div className="overflow-hidden">
                    <div className="float-right m-1">
                        <span className={product.status.includes("PENDING") ? "status-btn-pending" : "status-btn" }>
                            {product.status}
                        </span>
                    </div>
                    <div className="float-left">
                        <span style={{fontSize: 15, color: "dimgrey"}}><b>{product.productName}</b></span><br/>
                    </div>
                </div>
                <div className="overflow-hidden">
                    <div className="float-left">
                        <div className="pt-2">
                            <span className="color-lightgray small-text">Order Id: </span>
                            <b className="text-secondary">{product.orderId}</b>
                        </div>
                        <div className="mt-2">
                            <span className="color-lightgray small-text">Validity: </span>
                            <b className="text-secondary">{product.validityInMonths ? `${product.validityInMonths} Months` : "Under Process"}</b>
                        </div>
                        <div className="pt-2">
                            <span className="color-lightgray small-text">Provider: </span>
                            <b className="text-secondary">{product.distributorName}</b>
                        </div>
                    </div>
                    { product.status === ACTIVE && <div className="text-center claim-msg-box float-right mt-3">
                        <div className="item-container " onClick={() => this.handleDownloadInsurance(key)}>
                            <img src={`${imageBaseUrl}/img/icons/download.png`} alt="download" className="insurance-fa"/>
                            <span className="color-lightgray small-text download-policy-text">Download Policy</span>
                        </div>
                    </div>
                    }
                </div>
                {
                }
                { this.state.insurancePolicyDocError && this.state.clickedCardIndex === key &&
                <div className="text-center claim-msg-box my-2">
                    {this.state.insurancePolicyDocError}<br/>
                </div>
                }
                {   product.status === ACTIVE &&
                <div className="text-center claim-msg-box mt-3">
                    To claim your insurance policy please mail us at <br/>
                    <span className="shubh-color">support@myshubhlife.com</span>
                </div>
                }
            </div>
        );
   }

   public renderErrorResponseText = () => {
        return(
            <div className="text-center claim-msg-box mt-3">
                There was problem in Fetching Your Insurance Policies<br/>
                Contact <span className="shubh-color">support@myshubhlife.com</span>
            </div>
        );
   }

   public render() {
       return (
           <div className={`${this.state.containerClass} mt-4 insurance-policy-wraper `}>
               <Loading active={this.props.orderResponse === null || this.state.loading} />
               {floatingNavButton({label: "Available Insurances", routeTo: RoutePaths.CATEGORY_LIST})}
               {this.props.orderResponse === "SUCCESS" ? this.renderAllInsurances() : this.renderErrorResponseText()}
           </div>
       );
   }
}

const mapStateToProps = (state: IReduxState): IConnectProps => {
    return {
        userId: state.login.auth.userId,
        orders: state.insurance.insuranceOrders,
        orderResponse: state.insurance.insuranceOrderResponse,
        insuranceBase64Document: state.insurance.insuranceBase64Document,
        isAndroid: state.login.isAndroid,
    };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(ActiveInsurances);
